import { render } from "./materialtranscation.vue?vue&type=template&id=65d30a2f&scoped=true"
import script from "./materialtranscation.vue?vue&type=script&lang=js"
export * from "./materialtranscation.vue?vue&type=script&lang=js"

import "./materialtranscation.vue?vue&type=style&index=0&id=65d30a2f&scoped=true&lang=css"
import "./materialtranscation.vue?vue&type=style&index=1&id=65d30a2f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d30a2f"]])

export default __exports__